import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CopyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Copy",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9.86 13.29c-.63 0-1.14-.51-1.14-1.14 0-1.89 1.54-3.43 3.43-3.43a1.14 1.14 0 1 1 0 2.28c-.63 0-1.14.51-1.14 1.14s-.51 1.14-1.14 1.14ZM12.14 29.29c-1.89 0-3.43-1.54-3.43-3.43a1.14 1.14 0 1 1 2.28 0c0 .63.51 1.14 1.14 1.14a1.14 1.14 0 1 1 0 2.28ZM25.86 29.29a1.14 1.14 0 1 1 0-2.28c.63 0 1.14-.51 1.14-1.14a1.14 1.14 0 1 1 2.28 0c0 1.89-1.54 3.43-3.43 3.43ZM28.14 13.29c-.63 0-1.14-.51-1.14-1.14s-.51-1.14-1.14-1.14a1.14 1.14 0 1 1 0-2.28c1.89 0 3.43 1.54 3.43 3.43 0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.29 22.43c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c1.89 0 3.43 1.54 3.43 3.43a1.14 1.14 0 1 1-2.28 0c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14V19c0 .63.51 1.14 1.14 1.14a1.14 1.14 0 1 1 0 2.28Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.86 22.43c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M28.14 22.43c-.63 0-1.14-.51-1.14-1.14v-4.57a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M21.29 29.29h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28M21.29 11h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};
CopyIcon.displayName = 'CopyIcon';